import { FC, ReactNode, useEffect, useMemo, useRef, useState } from "react";

export const ReactiveWidthContainer: FC<{ builder: (width: number) => ReactNode }> = (props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [width, setWidth] = useState(0)
  const children = useMemo(() => {
    return props.builder(width)
  }, [props.builder, width])
  useEffect(() => {
    if (containerRef.current) {
      setWidth(containerRef.current.clientWidth)
    }
  }, [containerRef.current])
  useEffect(() => {
    const resizeHandler = () => {
      if (containerRef.current) {
        setWidth(containerRef.current.clientWidth)
      }
    }
    window.addEventListener('resize', resizeHandler)
    return () => {
      window.removeEventListener('resize', resizeHandler)
    }
  }, [])
  return <div ref={containerRef}>
    {children}
  </div>
}
